import React from "react";


import '../../css/style.css'
import '../../css/bootstrap-grid.css'
import '../../css/bootstrap-reboot.css'
import '../../css/bootstrap.min.css'
import '../../css/aos.css'
//import '../../css/owl.theme.default.min.css'
//import '../../css/owl.carousel.min.css'



class Aboutusherotext extends React.Component {
  render() {
    return (
      <div
        className="col-md-10 text-center text-md-left"
      >
        <h1 className="bg-text-line">About <br>
        </br> White Tigers FC</h1>
        <p className="mt-4">
        Founded in 2019, White Tigers Futbol Club is an American Soccer club currently based in Escondido, California.
        </p>
      </div>
    );
  }
}

export default Aboutusherotext;
